<!--
-->


<template>
    <div>
        <transition name="home-visual__img" v-for="(visual, index) in visual_list" :key="index">
            <img :src="visual" alt="" class="home-visual__img u-sz-w100" v-show="now === index">
        </transition>
    </div>
</template>


<script>
// プリロードクラス
import preload from '../../js/caracol_es2015.1.0/util/preload';


export default {
    data() {
        return {
            filename_base: `img/home/visual_{id}_${this.target}.jpg`,
            visual_list: [],
            // ランダムに画像を読ませるためのID一覧
            id_list: [1, 2, 3],
            // 何番目の画像を表示するか
            now: -1
        };
    },
    props: {
        target: String
    },
    computed: {
    },
    methods: {
        /**
        * 画像を変更する
        */
        change_image() {
            setInterval(() => {
                const next = (this.now + 1) % this.visual_list.length;
                this.now = next;
            }, 5000);
        },
        /**
        * 画像を読み込む
        */
        load_image() {

            // 画像をランダムに選ぶ
            const idx = Math.floor(this.id_list.length * Math.random());
            const id = this.id_list.splice(idx, 1)[0];
            const url = this.filename_base.replace('{id}', id);

            // console.log("load_image", url);

            preload([url])
                .done(() => {
                    this.visual_list.push(url);

                    // まだ表示していないなら0番目を表示
                    if (this.now < 0) {
                        this.now = 0;
                        this.change_image();
                    }
                    // 残り画像があるなら続いて読み込む
                    if (this.id_list.length) {
                        this.load_image();
                    }
                });
        }
    },
    created() {
        // console.log("created");
        this.load_image();
    }
};
</script>



// WEBPACK FOOTER //
// home-visual.vue?afb5c60e